function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

(function () {
  // show menu on hover with animation
  const nav = document.querySelector(".header__inline-menu");
  if (!nav) return;
  nav.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    let open = false;
    let isClosing = null;
    let isClosingFinally = null;
    let animateEl;
    summary.addEventListener("click", (event) => {
      const menuDetails = event.currentTarget.closest("details");
      if (menuDetails.getAttribute("open")) return;
      event.preventDefault();

      if (isClosing) {
        isClosing.cancel();
        isClosing = null;
      }
      if (isClosingFinally) {
        isClosingFinally.cancel();
        isClosingFinally = null;
      }

      const menuListContainer = menuDetails.closest("ul");
      event.currentTarget.setAttribute("aria-expanded", "true");
      menuDetails.setAttribute("open", "true");
      const details = menuDetails.querySelector(".mega-menu__content");
      const detailHeight = details.clientHeight;
      // if event.type
      animateEl = details.animate(
        [{ maxHeight: "0" }, { maxHeight: `${detailHeight}px` }],
        {
          duration: 500,
          easing: "cubic-bezier(0.4, 0, 0.2, 1)",
        }
      );
    });
  });
})();

/*
(function () {
  // show menu on hover with animation
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;
  nav.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    let open = false;
    let isClosing = null;
    let isClosingFinally = null;
    let animateEl;
    summary.addEventListener('mouseover', (event) => {
      if (open && event.type == 'mouseover') return;

      if (isClosing) {
        isClosing.cancel();
        isClosing = null;
      }
      if (isClosingFinally) {
        isClosingFinally.cancel();
        isClosingFinally = null;
      }

      open = true;

      const menuDetails = event.currentTarget.closest('details');
      const menuListContainer = menuDetails.closest('ul');
      event.currentTarget.setAttribute('aria-expanded', 'true');
      menuDetails.setAttribute('open', 'true');
      const details = menuDetails.querySelector('.mega-menu__content');
      const detailHeight = details.clientHeight;
      // if event.type
      animateEl = details.animate([{ maxHeight: '0' }, { maxHeight: `${detailHeight}px` }], {
        duration: 500,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      });

      menuListContainer.addEventListener('mouseleave', () => {
        open = false;
        if (isClosing) return;
        const detailHeight = details.clientHeight;
        isClosing = details.animate([{ maxHeight: `${detailHeight}px` }, { maxHeight: '0' }], {
          duration: 500,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });

        isClosing.onfinish = () => {
          menuDetails.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          isClosing = null;
        };
      });

      menuDetails.addEventListener('mouseleave', () => {
        open = false;
        if (isClosingFinally) return;
        const detailHeight = details.clientHeight;
        isClosingFinally = details.animate([{ maxHeight: `${detailHeight}px` }, { maxHeight: '0' }], {
          duration: 500,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });

        isClosingFinally.onfinish = () => {
          menuDetails.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          isClosingFinally = null;
        };
      });
    });

    let isClosingonClick;
    summary.addEventListener('click', (event) => {
      const menuDetails = event.currentTarget.closest('details');
      const details = menuDetails.querySelector('.mega-menu__content');
      const detailHeight = details.clientHeight;
      if (open) {
        open = false;
        event.preventDefault();

        if (isClosingonClick) {
          isClosingonClick.cancel();
          isClosingonClick = null;
        }

        if (isClosingonClick) return;

        isClosingonClick = details.animate([{ maxHeight: `${detailHeight}px` }, { maxHeight: '0' }], {
          duration: 500,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });

        isClosingonClick.onfinish = () => {
          menuDetails.removeAttribute('open');
          isClosingonClick = null;
        };
      } else {
        details.animate([{ maxHeight: '0' }, { maxHeight: '1000px' }], {
          duration: 500,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });
        open = true;
      }
    });
  });
})();
*/
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector,.accordion-heading)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle
      .querySelectorAll("details:not(.js-remain-opened)")
      .forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest(
            "deferred-media, product-model, .product-media-modal__content, .product-media-modal__arrow"
          )
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
    if (window.template.location == "product") this.playOnIntersect();
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
  playOnIntersect() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadContent();
          observer.unobserve(this);
        }
      });
    }, options);

    observer.observe(this);
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.sliderCounter = this.querySelector(".slider-counter");

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
    if (this.sliderCounter)
      this.sliderCounter.classList.remove("pause-animation");
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
    if (this.sliderCounter) this.sliderCounter.classList.add("pause-animation");
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    if (!currentSlide || !nextSlide) return;
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateBundleVariant();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateBundleVariant() {
    const selectElement = document.querySelector("[data-product-select]");
    if (selectElement) {
      // Check if the value exists among the options
      for (let i = 0; i < selectElement.options.length; i++) {
        if (Number(selectElement.options[i].value) === this.currentVariant.id) {
          selectElement.value = this.currentVariant.id;
          selectElement.dispatchEvent(new Event("change"));
        }
      }
    }
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // if a disabled input is selected, change the selected input to the first available input.
      const selectedOptionisDisabled = optionInputs.filter(
        (el) => el.checked && el.classList.contains("disabled")
      );
      if (selectedOptionisDisabled.length)
        this.selectFirstAvaialbleInput(
          optionInputs,
          selectedOptionisDisabled[0]
        );
    });
  }

  selectFirstAvaialbleInput(options, checkedOption) {
    const ele = options.find((el) => !el.classList.contains("disabled"));
    if (ele) {
      setTimeout(() => {
        checkedOption.checked = false;
        ele.checked = true;
        this.onVariantChange();
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );

        const saleBadgeMobileSource = html.getElementById(
          `ProductSaleBadge-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const saleBadgeMobileDestination = document.getElementById(
          `ProductSaleBadge-${this.dataset.section}`
        );

        const selectedOptionSourceA = html.getElementById(
          `selectedOption-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-0`
        );
        const selectedOptionDestinationA = document.getElementById(
          `selectedOption-${this.dataset.section}-0`
        );

        const selectedOptionSourceB = html.getElementById(
          `selectedOption-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-1`
        );
        const selectedOptionDestinationB = document.getElementById(
          `selectedOption-${this.dataset.section}-1`
        );

        const selectedOptionSourceC = html.getElementById(
          `selectedOption-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }-2`
        );
        const selectedOptionDestinationC = document.getElementById(
          `selectedOption-${this.dataset.section}-2`
        );

        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (window?.location?.country == "DE") {
          const productShippingInfoGermany = document.querySelector(
            ".shipping_days_germany"
          );
          if (productShippingInfoGermany)
            productShippingInfoGermany.classList.remove("hidden");
        } else {
          const productShippingInfoOthers = document.querySelector(
            ".shipping_days_others"
          );
          if (productShippingInfoOthers)
            productShippingInfoOthers.classList.remove("hidden");
        }

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (saleBadgeMobileSource && saleBadgeMobileDestination) {
          saleBadgeMobileDestination.innerHTML =
            saleBadgeMobileSource.innerHTML;
        }

        const selectedSizeType = document.querySelector(
          `#productSwitcher-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          } [data-size-type].active-size`
        );

        if (selectedOptionSourceA && selectedOptionDestinationA) {
          if (selectedSizeType) {
            selectedOptionDestinationA.innerHTML =
              selectedOptionSourceA.innerHTML;

            [
              ...selectedOptionDestinationA.querySelectorAll(
                ".selected-option-value"
              ),
            ].forEach((size) => size.classList.add("hidden"));

            const activeSize = selectedOptionDestinationA.querySelector(
              `[data-selected-option-value="${selectedSizeType.dataset.sizeType}"]`
            );

            if (activeSize) activeSize.classList.remove("hidden");
          } else
            selectedOptionDestinationA.innerHTML =
              selectedOptionSourceA.innerHTML;
        }

        if (selectedOptionSourceB && selectedOptionDestinationB) {
          if (selectedSizeType) {
            selectedOptionDestinationB.innerHTML =
              selectedOptionSourceB.innerHTML;

            [
              ...selectedOptionDestinationB.querySelectorAll(
                ".selected-option-value"
              ),
            ].forEach((size) => size.classList.add("hidden"));

            const activeSize = selectedOptionDestinationB.querySelector(
              `[data-selected-option-value="${selectedSizeType.dataset.sizeType}"]`
            );

            if (activeSize) activeSize.classList.remove("hidden");
          } else
            selectedOptionDestinationB.innerHTML =
              selectedOptionSourceB.innerHTML;
        }

        if (selectedOptionSourceC && selectedOptionDestinationC) {
          if (selectedSizeType) {
            selectedOptionDestinationC.innerHTML =
              selectedOptionSourceC.innerHTML;

            [
              ...selectedOptionDestinationC.querySelectorAll(
                ".selected-option-value"
              ),
            ].forEach((size) => size.classList.add("hidden"));

            const activeSize = selectedOptionDestinationC.querySelector(
              `[data-selected-option-value="${selectedSizeType.dataset.sizeType}"]`
            );

            if (activeSize) activeSize.classList.remove("hidden");
          } else
            selectedOptionDestinationC.innerHTML =
              selectedOptionSourceC.innerHTML;
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class accordionContent extends HTMLElement {
  constructor() {
    super();
    this.accordionHeading = this.querySelector(".accordion-heading");
    this.accordionContent = this.querySelector(".accordion-content-wrapper");

     if (!this.accordionHeading || !this.accordionContent) {
      console.warn("Missing required elements in AccordionContent.");
      return;
    }

    this.accordionHeading.addEventListener(
      "click",
      this.toggleContent.bind(this)
    );

    if (this.classList.contains("accordion__open")) this.toggleContent()
  }

  toggleContent() {
    if (this.dataset.open) {
      this.accordionContent.style.maxHeight = this.accordionContent.scrollHeight + 'px';
      this.accordionContent.classList.remove('accordion__open');
      this.removeAttribute('data-open');
      this.accordionHeading.classList.toggle('accordion__active');
      
      setTimeout(() => {
        this.accordionContent.style.maxHeight = null;
      }, 100);

      return;
    }
    this.accordionHeading.classList.toggle("accordion__active");
    this.accordionContent.style.maxHeight
      ? (this.accordionContent.style.maxHeight = null)
      : (this.accordionContent.style.maxHeight =
          this.accordionContent.scrollHeight + "px");
  }
}

customElements.define("accordion-content", accordionContent);

class quickBuy extends HTMLElement {
  constructor() {
    super();
    this.listOnly = this.classList.contains("list-only") ? true : false;
    this.quickbuyButton = this.querySelector(".quick-add-btn button");
    this.quickbuyWrapper = this.closest(".product-card-wrapper");
    this.cart = document.querySelector("cart-drawer");
    this.variantButtonsWrapper = this.querySelector(".card-grid-options-size");

    if (this.listOnly) {
      this.classList.add("quick-buy--active");
      this.variantButtonsWrapper.classList.add("card-buttons-enabled");
    } else {
      this.addEventListener("mouseover", this.showVariants);
      this.addEventListener("click", this.showVariants);
    }

    this.variantButtons = [...this.querySelectorAll("[data-quick-add]")];
    this.handleVariantBuy();
  }

  showVariants() {
    this.classList.add("quick-buy--active");
    this.quickbuyWrapper.addEventListener("mouseleave", () => {
      this.hideVariants();
    });
    window.setTimeout(() => {
      this.variantButtonsWrapper.classList.add("card-buttons-enabled");
    }, 300);
  }

  hideVariants() {
    this.classList.remove("quick-buy--active");
    this.variantButtonsWrapper.classList.remove("card-buttons-enabled");
  }

  handleVariantBuy() {
    this.variantButtons.forEach((variantButton) => {
      if (document.querySelector("cart-drawer"))
        variantButton.setAttribute("aria-haspopup", "dialog");

      variantButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleErrorMessage();
        const cartUpsell = variantButton.getAttribute("cart-upsell");
        variantButton.setAttribute("aria-disabled", true);
        let formData = {
          items: [
            {
              id: variantButton.id,
              quantity: 1,
            },
          ],
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        };

        if (cartUpsell) {
          formData.items[0].properties = {
            _cart_upsell_item: true,
          };
        }

        this.cart.setActiveElement(document.activeElement);

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "quick-buy",
                productVariantId: variantButton.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: variantButton.id,
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) variantButton.removeAttribute("aria-disabled");
          });
      });
    });
  }
  handleErrorMessage(errorMessage = false) {
    window.clearTimeout(this.setErrorMsgTimeout);
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".quick-buy__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".quick-buy__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }

    this.setErrorMsgTimeout = window.setTimeout(() => {
      this.errorMessageWrapper.setAttribute("hidden", true);
    }, 5000);
  }

  setErrorTimeout(el) {
    el.setAttribute("hidden", true);
  }
}

customElements.define("quick-buy", quickBuy);

(function () {
  const searchButton = [...document.querySelectorAll(".search-modal-toggle")];
  const searchModal = document.querySelector("header-search");
  const mainPageContent = document.querySelector("main");
  const menuDrawer = document.querySelector("header-drawer");
  if (!searchModal || !mainPageContent) return;

  const searchInput = searchModal.querySelector(".search__input");
  if (!searchInput) return;

  searchButton.forEach((button) => {
    button.addEventListener("click", (e) => {
      if (menuDrawer) {
        const menuDetail = menuDrawer.querySelector(".menu-drawer-container");
        if (menuDetail.hasAttribute("open")) {
          menuDrawer.closeSubmenu(menuDetail);
          menuDrawer.closeMenuDrawer(e, button);
        }
      }
      searchModal.toggleAttribute("open-modal");
      mainPageContent.classList.toggle("hidden");

      searchInput.hasFocus ? searchInput.blur() : searchInput.focus();
    });
  });
})();

(function () {
  const countrySelectorBtn = document.querySelector(".country_selector");
  const countrySelectorModal = document.querySelector(
    ".country-selector-modal"
  );
  const countrySelectorOverlay = document.querySelector(".csm-overlay");

  if (!countrySelectorBtn || !countrySelectorModal || !countrySelectorOverlay)
    return;

  countrySelectorBtn.addEventListener("click", () => {
    countrySelectorModal.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  });

  countrySelectorOverlay.addEventListener("click", () => {
    countrySelectorModal.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  });
})();

(function () {
  async function fetchLocation() {
    try {
      const response = await fetch("/browsing_context_suggestions.json");
      const data = await response.json();
      const country = data.detected_values.country.handle;
      window.location.country = country;

      if (window?.location?.country == "DE") {
        const productShippingInfoGermany = document.querySelector(
          ".shipping_days_germany"
        );
        if (productShippingInfoGermany)
          productShippingInfoGermany.classList.remove("hidden");
      } else {
        const productShippingInfoOthers = document.querySelector(
          ".shipping_days_others"
        );
        if (productShippingInfoOthers)
          productShippingInfoOthers.classList.remove("hidden");
      }

      /*
      const progressBar = document.querySelector('.drawer__shipping .progress__bar');
      const fulfilledTextEl = document.querySelector('.drawer__shipping .progress_text');

      const progressBarMain = document.querySelector('#main-cart-items .drawer__shipping .progress__bar');
      const fulfilledTextMainEl = document.querySelector('#main-cart-items .drawer__shipping .progress_text');

      if (progressBar && fulfilledTextEl) {
        progressBar.style.width = '100%';
        progressBar.classList.add('free_shipping_fulfilled');
        fulfilledTextEl.innerHTML = `<svg class="w-auto h-3 mr-1.5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><circle cx="12" cy="12" r="11.5" fill="black" stroke="black"></circle><path d="M7 12.998L10 15.998L18 6.99805" stroke-width="2" stroke="white"></path></svg><span class="progress-fulfilled">${fulfilledTextEl.dataset.fulfilled}</span>`;
      }

      if (progressBarMain && fulfilledTextMainEl) {
        progressBarMain.style.width = '100%';
        progressBarMain.classList.add('free_shipping_fulfilled');
        fulfilledTextMainEl.innerHTML = `<svg class="w-auto h-3 mr-1.5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><circle cx="12" cy="12" r="11.5" fill="black" stroke="black"></circle><path d="M7 12.998L10 15.998L18 6.99805" stroke-width="2" stroke="white"></path></svg><span class="progress-fulfilled">${fulfilledTextMainEl.dataset.fulfilled}</span>`;
      }
      */
    } catch (e) {
      console.error(e);
    }
  }
  fetchLocation();
})();

(function () {
  const dirButtons = [...document.querySelectorAll(".mobile-rec__arrow")];
  const itemContainer = document.querySelector(".mobile-rec-products");

  if (!(dirButtons.length && itemContainer)) return;
  dirButtons.forEach((button) => {
    button.addEventListener("click", () => {
      let scrollWidth = itemContainer.clientWidth;
      if (button.classList.contains("arrowNext-rec")) {
        scrollWidth = itemContainer.scrollLeft + scrollWidth;
      } else {
        scrollWidth = itemContainer.scrollLeft - scrollWidth;
      }
      itemContainer.scrollTo({
        top: 0,
        left: scrollWidth,
        behavior: "smooth",
      });
    });
  });
})();

(function () {
  [...document.querySelectorAll(".js_open_quickbuy")].forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
})();

class openQuickbuy extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector("a");
    this.link.addEventListener("click", this.handleLinkClick.bind(this));
  }

  handleLinkClick(e) {
    e.preventDefault();
    const productWrapper = e.target.closest(".product-card-wrapper");
    if (!productWrapper) return;
    const quickBuy = productWrapper.querySelector("quick-buy");
    if (!quickBuy) return;
    quickBuy.showVariants();
  }
}

customElements.define("open-quickbuy", openQuickbuy);

class variantImage extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    if (!this.button) return;
    this.button.addEventListener(
      "mouseover",
      this.handleImageSwitch.bind(this)
    );
  }

  handleImageSwitch() {
    const imageUrl = this.button.dataset.image;
    const imageUrlHover = this.button.dataset.imageHover;
    this.productUrl = this.button.dataset.url;
    if (!(imageUrl && imageUrlHover)) return;

    const mediaWrapper = this.closest(".card--media");
    if (!mediaWrapper) return;

    const imageEl = mediaWrapper.querySelector(".card__media img");
    const imageElHover = mediaWrapper.querySelector(
      ".card__media img:nth-child(2)"
    );

    mediaWrapper.classList.add("loading-image");

    if (imageEl && imageUrl != "") imageEl.srcset = imageEl.src = imageUrl;
    if (imageElHover && imageUrlHover)
      imageElHover.srcset = imageElHover.src = imageUrlHover;

    if (imageElHover && !imageUrlHover) imageElHover.srcset = imageUrl;

    imageEl.onload = () => {
      mediaWrapper.classList.remove("loading-image");
      if (this.productUrl) this.switchUrl(mediaWrapper);
      this.switchAtiveColor(mediaWrapper);
    };
  }
  switchUrl(el) {
    const curUrlEles = [...el.querySelectorAll("a")];
    curUrlEles.forEach((ele) => (ele.href = this.productUrl));
  }

  switchAtiveColor(el) {
    const curActive = el.querySelector(".current-active-color");
    if (curActive) curActive.classList.remove("current-active-color");
    this.button.classList.add("current-active-color");
  }
}

customElements.define("variant-image", variantImage);

class ModelView extends HTMLElement {
  constructor() {
    super();
    this.spanInput = this.querySelector('.span-input');
    this.collectionGridEl = document.querySelector('.collection-grid-container');
    this.label = this.querySelector(".model-view-label");
    if (!this.label || !this.spanInput || !this.collectionGridEl) return;
  
    this.label.addEventListener("click", this.updateView.bind(this));
  }

  updateView() {
    this.spanInput.classList.toggle('checked');
    this.collectionGridEl.classList.toggle('model-view-active', this.spanInput.classList.contains('checked'));
  }
}

customElements.define("model-view", ModelView);

class collectionTab extends HTMLElement {
  constructor() {
    super();
    this.init();

    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", (e) => {
        if (e.target.classList.contains("tab-button"))
          this.handleActiveTab(e.target);
      });
    }
  }

  init() {
    this.tabContainer = this.querySelector("[collection-tabs]");
    // Use the globally defined debounce functionsd
    this.debouncedHandleTab = debounce(this.handleActiveTab.bind(this), 200);

    this.tabContainer.addEventListener("click", (event) => {
      const tab = event.target.closest("button");
      if (tab && !tab.classList.contains("active-tab")) {
        this.debouncedHandleTab(tab);
      }
    });
  }

  handleActiveTab(tab) {
    const tabId = tab.id.replace("tab-button-", "");

    // switch tab button
    const activeTab = this.querySelector("button.active-tab");
    if (activeTab) activeTab.classList.remove("active-tab");
    
    tab.classList.add("active-tab");

    // Switch tab content
    const activeContent = this.querySelector(
      "slider-component.active_tab_content"
    );
    if (activeContent) activeContent.classList.remove("active_tab_content");

    const newContent = this.querySelector(
      `slider-component#tab-content-${tabId}`
    );
    if (newContent) newContent.classList.add("active_tab_content");

    // Switch tab image
    const activeImage = this.querySelector('.collection-block-image.active_tab_image');
    if (activeImage) activeImage.classList.remove('active_tab_image');

    const newImage = this.querySelector(`.collection-block-image#tab-image-${tabId}`);
    if (newImage) newImage.classList.add('active_tab_image');
  }
}

customElements.define("collection-tab", collectionTab);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.time = this.dataset.time;
    this.timerEl = this.querySelector("#timer");
    this.renderTimer();
  }

  renderTimer() {
    if (!this.time || !this.timerEl) return;
    const countDownDate = new Date(this.time).getTime();
    const currentTime = new Date().getTime();
    const timeLeft = countDownDate - currentTime;

    if (timeLeft < 0) {
      this.remove();
      return;
    }

    // Update the count down every 1 second
    var x = setInterval(() => {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      this.timerEl.innerHTML = `<span>${days}d ${hours}h ${minutes}m ${seconds}s</span>`;

      // If the count down is over, write some text
      if (distance < 0) {
        window.clearInterval(x);
        this.remove();
      }
    }, 1000);
  }
}

customElements.define("countdown-timer", CountdownTimer);


(function(){
  const rewardWrapper = document.querySelector('[data-lion-integrated-page]');
  if (!rewardWrapper) return;
  rewardWrapper.addEventListener('click', (e)=> {
    const rewardHeader = e.target.closest('.lion-tier-box__header');
    if (!rewardHeader) return;
    rewardHeader.parentElement.classList.toggle('opened');
  });
})();

// Define a custom HTMLVideo element class that extends HTMLElement
class HTMLVideoElement extends HTMLElement {
  constructor() {
    super();

    // Create a shadow DOM
    this.attachShadow({ mode: 'open' });

    // Create a container for the slot
    const container = document.createElement('div');

    // Add a slot for the video element
    const slot = document.createElement('slot');
    container.appendChild(slot);

    // Append the container to the shadow DOM
    this.shadowRoot.appendChild(container);

    // Intersection Observer instance
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      });
    });
  }

  connectedCallback() {
    // Get the video element from the light DOM
    this.video = this.querySelector('video');

    if (this.video) {
      // Ensure the video element has the required attributes
      this.video.setAttribute('autoplay', '');
      this.video.setAttribute('muted', '');
      this.video.setAttribute('loop', '');

      // Observe the custom element (container)
      this.observer.observe(this);
    } else {
      console.warn('No <video> element found inside <html-video>.');
    }
  }

  disconnectedCallback() {
    // Disconnect the observer when the element is removed
    this.observer.disconnect();
  }

  playVideo() {
    if (this.video) {
      this.video.play().catch((err) => {
        console.error('Error playing video:', err);
      });
    }
  }

  pauseVideo() {
    if (this.video) {
      this.video.pause();
    }
  }
}

customElements.define('html-video', HTMLVideoElement);

(function(){
  const m_observer = new MutationObserver((mutationsList, m_observer) => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'X-FIBBL-MODAL-WINDOW') {
            console.log('The <x-fibbl-modal-window> element was added:', node);
            const modalWindow = document.querySelector('x-fibbl-modal-window');
              // Access the shadow root of the element
              const shadowRoot = modalWindow.shadowRoot;
              const loadingWindow = shadowRoot.querySelector('x-fibbl-loading-screen');
              // Add new styles to the shadow DOM
              const styleElement = document.createElement('style');
              styleElement.textContent = `
                x-fibbl-powered-by {
                  display: none!important; 
                }
              `;
              shadowRoot.appendChild(styleElement);
  
              // Access the shadow root of the element
              const lWshadowRoot = loadingWindow.shadowRoot;
              // Add new styles to the shadow DOM
              const lwstyleElement = document.createElement('style');
              lwstyleElement.textContent = `
                x-fibbl-powered-by {
                  display: none!important; 
                }
              `;
              lWshadowRoot.appendChild(lwstyleElement);
          }
        });
      }
    });
  });
  const m_config = { childList: true, subtree: true }; 
  m_observer.observe(document.body, m_config);
})();

class ShopLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const resizeObserver = new ResizeObserver((entries) => this.setImageHeight());
    resizeObserver.observe(this);
  }
  setImageHeight() {
    this.image = this.querySelector('.shop-the-look-image');
    this.image && this.style.setProperty("--image-height", `${this.image.clientHeight}px`);
  }
}

customElements.define('shop-look', ShopLook);


